import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationToastComponent } from '../../components/confirmation-toast/confirmation-toast.component';
import { DialogService } from 'src/app/services/dialog.service';
import { faArrowRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from 'src/app/services/report.service';

@Component({
  selector: 'app-send-back-report',
  templateUrl: './send-back-report.component.html',
  styleUrl: './send-back-report.component.scss',
  standalone: false
})
export class SendBackReportComponent {
  userText: string;
  faArrowRotateLeft = faArrowRotateLeft;

  constructor(
    public dialogRef: MatDialogRef<SendBackReportComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly toast: ConfirmationToastComponent,
    private readonly dialogService: DialogService,
    private readonly reportService: ReportService,
  ) {
    dialogRef.disableClose = true;
    this.userText = "Are you sure you want to revert report <b>" + this.data.report.report_id + "</b> back to 'ready for submission' and remove all signatures?"
  }

  revertReport(): void {
    this.dialogService.openSpinner();
    this.data.report.signatures.forEach((signature: any) => {
      this.reportService.deleteSignature(signature.report_signature_id).subscribe();
    });
    this.reportService.updateReport({
      report_id: this.data.report.report_id,
      report_status_id: 1,
      authorization_status_id: null,
      regional_funding_status_id: null,
      regional_approval_status_id: null,
      wo_funding_status_id: null,
      wo_approval_status_id: null
    }).subscribe({
      next: (response: any) => {
        this.dialogService.closeSpinner();
        this.toast.openSuccessSnackBar(`${this.data.report.report_id} has been reverted.`);
        this.dialogRef.close(true);
      },
      error: (response: any) => {
        this.toast.openErrorSnackBar(`There was an error updating ${this.data.report.report_id}.`, "Please try reverting the report again.");
        this.dialogRef.close();
      },
    });
  }

  close(): void {
    this.dialogRef.close(false);
  }
}